import http from "services";
import { Lang } from "./types";

namespace reference {
  export const listLang = () =>
    http.post<Lang[]>("/guest/reference/lang/list", {});
}

export default reference;
